'use client';

export type UserRole = 'admin' | 'manager' | 'cashier';

export interface StoredUser {
  id: string;
  name: string;
  email: string;
  role: UserRole;
}

export async function mockLogin(
  email: string,
  password: string
): Promise<{ success: boolean; token?: string; user?: StoredUser }> {
  try {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) return { success: false };

    const { token, user } = data as { token: string; user: StoredUser };
    if (typeof window !== 'undefined') {
      localStorage.setItem('droidcare_token', token);
      localStorage.setItem('droidcare_user', JSON.stringify(user));
    }
    return { success: true, token, user };
  } catch {
    return { success: false };
  }
}

export async function mockLogout(): Promise<void> {
  const token = typeof window !== 'undefined' ? localStorage.getItem('droidcare_token') : null;
  try {
    await fetch('/api/auth/logout', {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  } catch {
    // ignore
  }
  if (typeof window !== 'undefined') {
    localStorage.removeItem('droidcare_token');
    localStorage.removeItem('droidcare_user');
  }
}

export function getStoredUser(): StoredUser | null {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem('droidcare_user');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  if (typeof window === 'undefined') return false;
  return !!localStorage.getItem('droidcare_token');
}

export function getCurrentUserRole(): UserRole {
  const user = getStoredUser();
  return user?.role ?? 'cashier';
}
